<div id="title--container">
  <h4>Device Messages</h4>
  <h5>{{ laboratory()?.laboratoryName }}</h5>
</div>
<hr />
<div id="inner-page--container">
  <div id="toggle--container">
    <app-underlined-option-tab-toggle
      radioGroup="navigationToggle"
      [selectOptions]="navOptions"
    >
    </app-underlined-option-tab-toggle>
  </div>
  <hr />
  @if (isLoading) {
    <div id="loading--container">
      <app-loading-spinner></app-loading-spinner>
    </div>
  } @else {
    <div id="message--container">
      <div id="messages">
        <h6>Device Messages (Last 24 Hours)</h6>

        @if (getDeviceMessagesError) {
          <div class="no-messages">
            <span class="error">
              Error: {{ getDeviceMessagesError.message }}
            </span>
          </div>
        }
        @if (!getDeviceMessagesError && deviceMessages.length === 0) {
          <div class="no-messages">
            <mat-icon>chat_bubble</mat-icon>
            <span>No messages received from device</span>
          </div>
        }
        @if (!getDeviceMessagesError && deviceMessages.length > 0) {
          @for (item of deviceMessages; track $index) {
            <div class="message">
              <div class="message--header">
                <div class="subtitle2">
                  {{ item.createdAt | date: "mediumTime" }}
                </div>
                <div class="body2">
                {{ item.createdAt | date: "longDate" }}
                </div>
              </div>
              <div class="message--body">
                <span>{{ item.message }}</span>
              </div>
            </div>
            @if ($index < deviceMessages.length - 1) {
              <hr />
            }
          }
        }
      </div>
      <div id="message-form">
        <h6>Send Message</h6>
        <form [formGroup]="messageForm">
          <app-underlined-textarea-field
            [parentForm]="messageForm"
            [field]="messageField"
            [minLength]="messageMinLength"
            [maxLength]="messageMaxLength"
            rows="6"
            [showCharacterCounter]="true"
          >
          </app-underlined-textarea-field>
          <div id="button--container">
            <app-button
              label="Submit"
              buttonId="send-message-btn"
              buttonShape="square"
              (buttonClicked)="submitDeviceMessage()"
              [isProcessing]="isProcessing"
              [isDisabled]="
                messageForm.invalid ||
                !(currentUser.role
                  | roleCheck
                    : [
                        Role.OGI_Super_Administrator,
                      ])
              "
            ></app-button>
          </div>
        </form>
      </div>
    </div>
  }
</div>
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="submitMessageError?.message"
  primaryButtonText="close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="success"
  titleText="Success"
  primaryText="Message sent"
  primaryButtonText="Close"
  primaryButtonId="close-approval"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>